(function() {
'use strict';

angular
    .module('transfers')
    .service('transferSearchValidator', transferSearchValidator);

function transferSearchValidator(resourceService, dateUtil, occupancyService) {
    const service = {
        validate
    };

    function validate(destinationAirport, resort, direction, arrivalDate, returnDate, occupancy, locationId, transferType, pickUpPoint, dropOffPoint) {
        const errors = [];
        const airportToResort = 2;
        const resortToAirport = 3;
        const airportTransferType = 0;

        if (occupancyService.moreInfantsThanAdults()) {
            errors.push(resourceService.get('TOOMANYINFANTS'));
        }
        if (!occupancyService.childAgesPopulated()) {
            errors.push(resourceService.get('CHILDAGESERROR'));
        }

        if (transferType && transferType !== airportTransferType) {
            if (pickUpPoint == null) {
                errors.push(resourceService.get('SELECTPICKUPPOINT'));
            }
            if (dropOffPoint == null) {
                errors.push(resourceService.get('SELECTDROPOFFPOINT'));
            }
        } else {
            if (destinationAirport == null) {
                errors.push(resourceService.get('SELECTDESTINATIONAIRPORT'));
            }
            if (resort == null && locationId == null) {
                errors.push(resourceService.get('SELECTRESORT'));
            }
        }

        if (direction !== resortToAirport) {
            if (arrivalDate == null) {
                errors.push(resourceService.get('SELECTARRIVALDATETIME'));
            } else if (!dateUtil.atLeastOneDayInTheFuture(arrivalDate)) {
                errors.push(resourceService.get('ARRIVALDATEMUSTBEFUTURE'));
            }
        }

        if (direction !== airportToResort) {
            if (returnDate == null) {
                errors.push(resourceService.get('SELECTRETURNDATETIME'));
            } else if (direction !== airportToResort && returnDate <= arrivalDate) {
                errors.push(resourceService.get('RETURNDATEAFTERDEPARTUREDATE'));
            }
        }
        return errors;
    }

    return service;
}
})();
